// GSAP ScrollTrigger for hero content wrapper reveal animations
document.addEventListener("DOMContentLoaded", function () {
    // Wait for GSAP to be available
    const initHeroScrollTrigger = () => {
        if (
            typeof gsap !== "undefined" &&
            typeof ScrollTrigger !== "undefined"
        ) {
            // Register ScrollTrigger plugin
            gsap.registerPlugin(ScrollTrigger);

            const heroElements = gsap.utils.toArray(".hero__content-wrapper");
            const resourceElements = gsap.utils.toArray(
                ".resource-list slideshow-slides, .resource-list--grid"
            );
            const customElements = gsap.utils.toArray(
                ".custom-section-content .section-content-wrapper"
            );
            const groupRowElements = gsap.utils.toArray(
                ".custom-section-content .section-content-wrapper .layout-panel-flex--row"
            );
            // console.log(heroElements, resourceElements, customElements);

            heroElements.forEach((element, i) => {
                gsap.set(element.children, {
                    y: 30,
                    opacity: 0,
                    duration: 0.7,
                    ease: "power1.out",
                    overwrite: "auto",
                });
                ScrollTrigger.create({
                    trigger: element,
                    start: "center 80%",
                    once: true,
                    onEnter: () =>
                        gsap.to(element.children, {
                            delay: 0.3,
                            y: 0,
                            opacity: 1,
                            stagger: 0.15,
                        }),
                });
            });

            resourceElements.forEach((element, i) => {
                gsap.set(element.children, {
                    y: 30,
                    opacity: 0,
                    duration: 0.7,
                    ease: "power1.out",
                    overwrite: "auto",
                });
                ScrollTrigger.create({
                    trigger: element,
                    start: "top 80%",
                    once: false,
                    toggleActions: "play pause resume reverse",
                    onEnter: () =>
                        gsap.to(element.children, {
                            y: 0,
                            opacity: 1,
                            stagger: 0.15,
                        }),
                    onLeaveBack: () =>
                        gsap.to(element.children, {
                            delay: 0.5,
                            y: 30,
                            opacity: 0,
                            stagger: 0.15,
                        }),
                });
            });
            customElements.forEach((element, i) => {
                // Set starting params for sections
                gsap.set(element.children, {
                    y: 30,
                    opacity: 0,
                    duration: 0.7,
                    ease: "power1.out",
                    overwrite: "auto",
                });
                ScrollTrigger.create({
                    trigger: element,
                    start: "top 80%",
                    once: true,
                    onEnter: () =>
                        gsap.to(element.children, {
                            delay: 0.5,
                            y: 0,
                            opacity: 1,
                            stagger: 0.15,
                        }),
                });
            });
            groupRowElements.forEach((element, i) => {
                gsap.set(element.children, {
                    y: 30,
                    opacity: 0,
                    duration: 0.7,
                    ease: "power1.out",
                    overwrite: "auto",
                });
                ScrollTrigger.create({
                    trigger: element,
                    start: "top 90%",
                    once: false,
                    toggleActions: "play pause resume reverse",
                    onEnter: () =>
                        gsap.to(element.children, {
                            y: 0,
                            opacity: 1,
                            stagger: 0.15,
                        }),
                    onLeaveBack: () =>
                        gsap.to(element.children, {
                            y: 30,
                            opacity: 0,
                            stagger: 0.15,
                        }),
                });
            });
        } else {
            // Retry after a short delay if GSAP isn't loaded yet
            setTimeout(initHeroScrollTrigger, 100);
        }
    };

    // Initialize the ScrollTrigger
    initHeroScrollTrigger();
});
